import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const COLORS = {
  bergamot: "#95c11f",
  brown: "#683c11",
  white: "#ffffff",
};

const BuyDomainPage = () => {
  const [animateDomainName, setAnimateDomainName] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const domain = location.state?.domain || {
    name: "esempio",
    extension: "com",
    price: 20,
    category_name: "Tecnologia",
  };

  const [openFaqIndex, setOpenFaqIndex] = useState(null);
  const [yearsExtra, setYearsExtra] = useState(1);
  const [countdown, setCountdown] = useState(1800);
  const [isPurchased, setIsPurchased] = useState(false);
  const [purchaseAnimating, setPurchaseAnimating] = useState(false);

  const faqs = [
    {
      question: "Come funziona l'acquisto del dominio?",
      answer:
        "Selezioni il dominio, clicchi su 'Compra Ora' e verrai guidato nel processo di pagamento e registrazione.",
    },
    {
      question: "Posso trasferire il dominio altrove?",
      answer:
        "Sì, il dominio ti appartiene e puoi trasferirlo a qualsiasi provider dopo l'acquisto.",
    },
    {
      question: "Quanto tempo ci vuole per attivare il dominio?",
      answer:
        "L'attivazione avviene in genere entro 24 ore dal completamento della transazione.",
    },
    {
      question: "Offrite supporto post-vendita?",
      answer:
        "Assolutamente! Il nostro team è disponibile 24/7 per aiutarti con ogni necessità.",
    },
  ];

  useEffect(() => {
    // Se l'utente non è loggato, reindirizza alla homepage
      const token = localStorage.getItem('jwt_token');
        if (!adminVariable) {
          navigate('/login');
          return; // evita che il resto dell'useEffect venga eseguito
        }

    const timer = setTimeout(() => setAnimateDomainName(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (countdown <= 0) return;
    const interval = setInterval(() => setCountdown((c) => c - 1), 1000);
    return () => clearInterval(interval);
  }, [countdown]);

  const toggleFaq = (index) => {
    setOpenFaqIndex((prev) => (prev === index ? null : index));
  };

  const handlePurchase = () => {
  if (purchaseAnimating || isPurchased) return;
  setPurchaseAnimating(true);

  setTimeout(() => {
    const url = `/checkout?domain=${encodeURIComponent(domain.name)}&price=${domain.price}&years=${yearsExtra}&id=${domain.id_domain}`;
    navigate(url, { state: { domain, yearsExtra } });
  }, 1000);
};

const prezzoFinale = Number(domain.price) + (Number(yearsExtra - 1) * (Number(domain.price) * 0.7));
const prezzoFinaleFormattato = prezzoFinale.toFixed(2);

  const formatCountdown = (sec) => {
    const m = Math.floor(sec / 60).toString().padStart(2, "0");
    const s = (sec % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  return (
    <main
      className="min-h-screen w-full relative bg-white"
      style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}
    >
      <section
        className="w-full mb-10"
        style={{
          backgroundColor: COLORS.bergamot,
          color: COLORS.white,
          height: "30vh",
          display: "flex",
          alignItems: "center",
          padding: "0 2rem",
        }}
      >
        <div className="max-w-7xl mx-auto flex w-full">
          <div className="max-w-3xl">
            <h1 className="text-3xl lg:text-4xl font-bold tracking-wide text-left leading-tight">
              Vuoi comprare il dominio <br />
              <span
                className="font-extrabold inline-block"
                style={{
                  transform: animateDomainName ? "scale(1)" : "scale(0.1)",
                  transformOrigin: "left center",
                  transition: "transform 1.5s ease-out",
                  display: "inline-block",
                }}
              >
                {domain.name}.{domain.extension}
              </span>
              ?
            </h1>
          </div>
        </div>
      </section>

      <section className="relative max-w-7xl mx-auto flex flex-col lg:flex-row gap-8 px-0">
        <div className="flex-1 pr-6 max-w-3xl">
          <h2 className="text-3xl font-bold border-b border-gray-300 pb-3 mb-6">
            Domande frequenti
          </h2>
          {faqs.map((faq, i) => {
            const isOpen = openFaqIndex === i;
            return (
              <div
                key={i}
                onClick={() => toggleFaq(i)}
                className="cursor-pointer border-b border-gray-200 py-4"
              >
                <div className="flex justify-between items-center">
                  <h3 className="text-xl font-semibold text-gray-900">{faq.question}</h3>
                  <div
                    className={`text-3xl font-bold transition-transform duration-300 select-none ${
                      isOpen ? "text-green-600 rotate-45" : "text-gray-900 rotate-0"
                    }`}
                    style={{ userSelect: "none" }}
                  >
                    +
                  </div>
                </div>
                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out`}
                  style={{
                    maxHeight: isOpen ? "300px" : "0",
                    opacity: isOpen ? 1 : 0,
                    marginTop: isOpen ? "1rem" : "0",
                    transitionProperty: "max-height, opacity, margin-top",
                  }}
                >
                  <p
                    className="text-gray-700 leading-relaxed"
                    style={{ marginLeft: 0, paddingLeft: 0, textAlign: "left" }}
                  >
                    {faq.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <aside
          className="absolute top-0 right-0 w-full max-w-md bg-white border border-gray-300 rounded-2xl shadow-lg p-8"
          style={{ minHeight: "500px", marginTop: "-150px" }}
        >
          <h2 className="text-4xl font-extrabold mb-8 text-center text-gray-900">
            Acquista il dominio
          </h2>
          <div className="mb-6 text-lg font-semibold text-gray-800 space-y-4">
            <div className="flex justify-between items-center">
              <span>Dominio:</span>
              <span className="font-normal">{domain.name}.{domain.extension}</span>
            </div>
            <div className="flex justify-between items-center">
              <span>Categoria:</span>
              <span className="font-normal">{domain.category_name || "Non specificata"}</span>
            </div>
            <div className="flex justify-between items-center">
              <span>Prezzo base:</span>
              <span className="font-normal">€{domain.price}</span>
            </div>
            <label htmlFor="yearsExtra" className="block font-semibold">
              Anni aggiuntivi (€5/anno):
            </label>
            <input
              type="range"
              id="yearsExtra"
              min="1"
              max="10"
              value={yearsExtra}
              onChange={(e) => setYearsExtra(parseInt(e.target.value))}
              className="w-full cursor-pointer"
              style={{
                accentColor: COLORS.bergamot,
                height: "6px",
                backgroundColor: "rgba(0,0,0,0.1)",
                borderRadius: "9999px",
              }}
            />
            <div className="text-right font-bold mt-1">
              {yearsExtra} anno{yearsExtra > 1 ? "/i" : ""}
            </div>
          </div>
          <div
            className="text-center text-3xl font-extrabold mb-8"
            style={{ color: COLORS.bergamot }}
          >
            Prezzo finale: €{prezzoFinaleFormattato}
          </div>
          <button
            onClick={handlePurchase}
            disabled={purchaseAnimating || isPurchased}
            className={`w-full py-4 rounded-3xl text-white font-bold text-2xl shadow-lg
            transition-all duration-300
            ${isPurchased
              ? "bg-green-500 cursor-default"
              : purchaseAnimating
              ? "bg-green-700 cursor-wait animate-pulse"
              : "bg-green hover:bg-green-600 cursor-pointer"
              }`}
            style={{ backgroundColor: COLORS.bergamot }}
          >
            {isPurchased
              ? "Acquisto completato"
              : purchaseAnimating
              ? "Elaborazione..."
              : "Compra Ora"}
          </button>

          <div
            className="mt-12 font-mono text-xl text-center tracking-widest"
            style={{ color: COLORS.brown }}
          >
            {countdown > 0 ? (
              <>
                Bloccato per te:{" "}
                <span className="font-bold">{formatCountdown(countdown)}</span>
              </>
            ) : (
              <span className="text-red-600 font-bold">
                Tempo scaduto! Ricarica per riprovare.
              </span>
            )}
          </div>
        </aside>
      </section>
    </main>
  );
};

export default BuyDomainPage;
